import type React from 'react';
import classes from './employee-form-fields.module.scss';
import type { ShiftEmployeeSex } from '../../models/employees.types';
import { type EmployeeFormFieldsProps } from './employee-form-fields.types';

export const EmployeeFormFields: React.FC<EmployeeFormFieldsProps> = ({
  form,
  onChange,
  canEditSection,
  sectionOptions,
  sectionLabel,
}) => (
  <>
    <div className="formGrid">
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-first-name">
          שם פרטי <span className="requiredMark">*</span>
        </label>
        <input
          id="employee-first-name"
          className="input"
          value={form.firstName}
          onChange={(event) => onChange('firstName', event.target.value)}
          required
        />
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-last-name">
          שם משפחה <span className="requiredMark">*</span>
        </label>
        <input
          id="employee-last-name"
          className="input"
          value={form.lastName}
          onChange={(event) => onChange('lastName', event.target.value)}
          required
        />
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-email">
          אימייל
        </label>
        <input
          id="employee-email"
          className="input"
          type="email"
          dir="ltr"
          value={form.email}
          onChange={(event) => onChange('email', event.target.value)}
        />
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-phone">
          טלפון
        </label>
        <input
          id="employee-phone"
          className="input"
          dir="ltr"
          value={form.phoneNumber}
          onChange={(event) => onChange('phoneNumber', event.target.value)}
        />
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-sex">
          מין
        </label>
        <select
          id="employee-sex"
          className="input"
          value={form.sex}
          onChange={(event) => onChange('sex', event.target.value as '' | ShiftEmployeeSex)}
        >
          <option value="">לא נבחר</option>
          <option value="male">זכר</option>
          <option value="female">נקבה</option>
        </select>
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-birthdate">
          תאריך לידה
        </label>
        <input
          id="employee-birthdate"
          className="input"
          type="date"
          dir="ltr"
          value={form.birthdate}
          onChange={(event) => onChange('birthdate', event.target.value)}
        />
      </div>
      <div className="employeeFormField">
        <label className="label" htmlFor="employee-id-number">
          תעודת זהות
        </label>
        <input
          id="employee-id-number"
          className="input"
          dir="ltr"
          value={form.idNumber}
          onChange={(event) => onChange('idNumber', event.target.value)}
        />
      </div>
      <div className="employeeFormField">
        {canEditSection ? (
          <>
            <label className="label" htmlFor="employee-section">
              מחלקה
            </label>
            <select
              id="employee-section"
              className="input"
              value={form.sectionPk === '' ? '' : String(form.sectionPk)}
              onChange={(event) => {
                const value = event.target.value;
                onChange('sectionPk', value === '' ? '' : Number(value));
              }}
            >
              <option value="">ללא שיוך</option>
              {sectionOptions.map((section) => (
                <option key={section.id} value={section.id}>
                  {section.name}
                </option>
              ))}
            </select>
            {sectionOptions.length === 0 && (
              <p className={classes.fieldHint}>לא נמצאו מחלקות זמינות בטננט.</p>
            )}
          </>
        ) : (
          <>
            <label className="label">מחלקה</label>
            <div className={classes.readonlyValue}>{sectionLabel ?? '—'}</div>
          </>
        )}
      </div>
    </div>
  </>
);
